import React from 'react';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import { observer } from 'mobx-react';
import {
    ActionTypeText,
    AutomationBlockContent
} from '../AutomationsBuilder.styles';
import { AUTOMATION_FILE_TYPES } from '../../../../../utils/automation.utils';
import { TAutomationBlockAction } from '~/types/automation.types';

const AutomationBlockActionFile: TAutomationBlockAction = ({ step, color }) => {
    const { Icon, description } = AUTOMATION_FILE_TYPES[step.fileType];

    return (
        <AutomationBlockContent>
            <Icon color={color} />
            <ActionTypeText type="Title3DarkPrimary">
                {description}
            </ActionTypeText>
            <HBText
                align="center"
                type={
                    step.fileTemplateId
                        ? 'Body6DarkPrimary'
                        : 'Body6DarkSecondary'
                }
            >
                {step.title || 'Choose template on the right'}
            </HBText>
        </AutomationBlockContent>
    );
};

export default observer(AutomationBlockActionFile);
